import React from 'react';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';

export const InfoLabelRestore = () => {
  return (
    <StyledInfo>
      <StyledImageNLabelContainer>
        <StyledLabel>
          <Translate id="LABEL.INFO.LABEL.TITLE" />
        </StyledLabel>
        <StyledLabel>
          <StyledLabelTwo>
            <Translate id="USER_PROFILE.INFO.LABEL.RESTORE.LABEL" />
          </StyledLabelTwo>
          <StyledLabelTwo>
            <Translate id="USER_PROFILE.INFO.LABEL.RESTORE.LABEL.TWO" />
          </StyledLabelTwo>
          <UnOrderedList>
            <UnOrderedListItem>
              <Translate id="LABEL.INFO.RESTORE.LABEL.LIST.ITEM.ONE" />
            </UnOrderedListItem>
            <UnOrderedListItem>
              <Translate id="LABEL.INFO.RESTORE.LABEL.LIST.ITEM.TWO" />
            </UnOrderedListItem>
          </UnOrderedList>
        </StyledLabel>
      </StyledImageNLabelContainer>
    </StyledInfo>
  );
};

const StyledInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: rgb(247, 181, 0, 0.4);
  border-color: rgb(247, 181, 0, 0.4);
  border-radius: 4px;
  margin-bottom: 10px;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const UnOrderedList = styled.ul`
  display: block;
`;

const UnOrderedListItem = styled.li``;

const StyledLabel = styled.label`
  font-size: 14px;
  line-height: 17px;
  opacity: 1;
  color: ${({ theme }) => theme.colors.primary};
`;
const StyledLabelTwo = styled.label`
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.primary};
  margin-top: 10px;
  display: block;
`;

const StyledImageNLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
